import { SVGProps } from 'react';

const IceCreamBowl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 21h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0m.29 0a3.5 3.5 0 1 1 6.71 0M15.5 6.5a3.5 3.5 0 1 0-7 0M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6"
    />
  </svg>
);
export default IceCreamBowl;
